var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col",attrs:{"id":"footer"}},[_c('div',{staticClass:"text-center"},[_c('p',[_vm._v("© Copyright 2020 Online Supporter")])])])])])
}]

export { render, staticRenderFns }